import { render, staticRenderFns } from "./ScreenshotItem.vue?vue&type=template&id=898d3320&scoped=true&"
import script from "./ScreenshotItem.vue?vue&type=script&lang=js&"
export * from "./ScreenshotItem.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotItem.vue?vue&type=style&index=0&id=898d3320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d3320",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
